export type BrokerNerdsBarkerCoreEnumsDeliveryMethod = (typeof BrokerNerdsBarkerCoreEnumsDeliveryMethod)[keyof typeof BrokerNerdsBarkerCoreEnumsDeliveryMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokerNerdsBarkerCoreEnumsDeliveryMethod = {
  Unknown: 'Unknown',
  Electronic: 'Electronic',
  Physical: 'Physical',
  Instant: 'Instant',
  Special: 'Special',
} as const;
